export default {"src":"/_next/static/media/zoning_1.e29a0f98.gif","height":400,"width":700,"blurWidth":0,"blurHeight":0};